import React from 'react';
import { Trash2 } from 'lucide-react';

const DocumentUpload = ({ documents, handleDocumentUpload, handleDocumentRemove }) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-lg font-medium text-gray-900 mb-3">Documents de paiement</h3>
      <div className="grid grid-cols-2 gap-4">
        {['fichier1', 'fichier2'].map((field, index) => (
          <div key={field} className="relative">
            <label className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-white hover:bg-gray-50">
              <div className="flex flex-col items-center justify-center">
                <svg className="w-5 h-5 mb-1 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                  <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                </svg>
                <p className="text-xs text-gray-500 text-center">
                  <span className="font-semibold">Document {index + 1}</span>
                </p>
              </div>
              <input
                type="file"
                className="hidden"
                onChange={(e) => handleDocumentUpload(e, field)}
                accept=".pdf,.jpg,.jpeg,.png"
              />
            </label>
            
            {documents[field] && (
              <div className="absolute -top-2 -right-2">
                <button
                  type="button"
                  onClick={() => handleDocumentRemove(field)}
                  className="p-1 bg-red-500 text-white rounded-full hover:bg-red-600"
                >
                  <Trash2 className="h-3 w-3" />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocumentUpload;
